"use strict"
exports.__esModule = true;
exports.StackOverflowIconConfig = {
  name: 'StackOverflowIcon',
  height: 512,
  width: 384,
  svgPath: 'M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z',
  yOffset: 0,
  xOffset: 0,
};
exports.StackOverflowIcon = require('../createIcon').createIcon(exports.StackOverflowIconConfig);
exports["default"] = exports.StackOverflowIcon;